import { format, type Locale } from 'date-fns'

import { getDatepickerLocale as resolveDatepickerLocale } from '@dfds-pax/utils'

export function addDays(date: Date, days: number): Date {
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export function toShortDateString(date?: Date): string {
  if (!date) return '-'
  if (getDatepickerLocale().code === 'lv') return format(date, 'EEEEE dd/MM', { locale: getDatepickerLocale() })
  if (getDatepickerLocale().code === 'et') return format(date, 'EEEEE dd/MM', { locale: getDatepickerLocale() })
  return format(date, 'eee dd/MM', { locale: getDatepickerLocale() })
}

export function toDateString(date?: Date): string {
  if (!date) return '-'
  return format(date, 'eee PP', { locale: getDatepickerLocale() })
}

const getUrlLocale = (): string => {
  // Extract the locale from the URL path
  const localeFromPath = window.location.pathname.split('/')[1]

  // If a locale is found in the path, return it
  if (localeFromPath) return localeFromPath

  // Otherwise, extract the locale from the search parameters which is needed for travel-search used by the app
  const url = new URL(window.location.href)
  const locale = url.searchParams.get('searchConfig')?.split('/')[0]

  // Return the locale if found, otherwise default to 'en'
  return locale || 'en'
}

export function getDatepickerLocale(): Locale {
  return resolveDatepickerLocale(getUrlLocale())
}
